var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.orderDatalist
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "订单信息",
                visible: _vm.dialogVisible,
                width: "1000px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
                close: function ($event) {
                  return _vm.$refs.oneCardOrderItemDialog.close()
                },
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "description",
                },
                [
                  _c("div", { staticClass: "title" }, [_vm._v("基础信息")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    [
                      _vm._l(_vm.baseOption, function (item) {
                        return _c(
                          "div",
                          {
                            key: item.dataIndex,
                            staticClass: "description-term",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                item.title +
                                  "：" +
                                  (_vm.orderDatalist[item.dataIndex] || "--")
                              )
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.orderDatalist.type === 110
                        ? _c("div", { staticClass: "description-term" }, [
                            _vm._v(
                              "充值手机号：" +
                                _vm._s(_vm.orderDatalist.rechargePhone || "--")
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.orderDatalist.jdOrderNo
                        ? _c("div", { staticClass: "description-term" }, [
                            _vm._v(
                              "京东订单号：" +
                                _vm._s(_vm.orderDatalist.jdOrderNo)
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _vm.orderDatalist.dynamicFormInfo
                    ? [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("表单信息"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          [
                            _c(
                              "el-card",
                              {
                                staticClass: "form-info-card",
                                attrs: { shadow: "hover" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-card-header",
                                    attrs: { slot: "header" },
                                    slot: "header",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "form-card-title" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.orderDatalist.dynamicFormInfo
                                              .title || "表单内容"
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "13px",
                                          color: "#909399",
                                          margin: "4px 0 0 0",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t  表单ID: " +
                                            _vm._s(
                                              _vm.orderDatalist.dynamicFormId ||
                                                "--"
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t  "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "16px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "表单值ID: " +
                                                _vm._s(
                                                  _vm.orderDatalist
                                                    .dynamicFormValueId || "--"
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "form-card-time" },
                                          [
                                            _vm._v(
                                              "提交时间: " +
                                                _vm._s(
                                                  _vm.orderDatalist
                                                    .dynamicFormInfo
                                                    .submitTime || "--"
                                                )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "copy-btn",
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                              icon: "el-icon-document-copy",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copyFormData(
                                                  _vm.orderDatalist
                                                    .dynamicFormInfo
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t复制表单数据\n\t\t\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.orderDatalist.dynamicFormInfo.formItems &&
                                _vm.orderDatalist.dynamicFormInfo.formItems
                                  .length > 0
                                  ? [
                                      _c(
                                        "el-table",
                                        {
                                          staticClass: "form-table",
                                          attrs: {
                                            data: _vm.orderDatalist
                                              .dynamicFormInfo.formItems,
                                            size: "mini",
                                            "header-cell-style": {
                                              background: "#f5f7fa",
                                              color: "#606266",
                                              fontWeight: "bold",
                                              padding: "12px",
                                            },
                                            "cell-style": {
                                              padding: "12px",
                                            },
                                          },
                                        },
                                        [
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "title",
                                              label: "字段名称",
                                              "min-width": "150",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "field-name",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                scope.row
                                                                  .title ||
                                                                  "未命名"
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                          ),
                                                          scope.row.required
                                                            ? _c(
                                                                "el-tag",
                                                                {
                                                                  attrs: {
                                                                    size: "mini",
                                                                    type: "danger",
                                                                  },
                                                                },
                                                                [_vm._v("必填")]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      scope.row.key
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-id",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "ID: " +
                                                                  _vm._s(
                                                                    scope.row
                                                                      .key
                                                                  )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              4201723944
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "填写内容",
                                              "min-width": "250",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      scope.row.type ===
                                                      "checkbox"
                                                        ? [
                                                            scope.row.value &&
                                                            scope.row.value.startsWith(
                                                              "["
                                                            )
                                                              ? [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "form-item-tags",
                                                                    },
                                                                    [
                                                                      _vm._l(
                                                                        _vm.parseFormValue(
                                                                          scope
                                                                            .row
                                                                            .value
                                                                        ),
                                                                        function (
                                                                          val,
                                                                          idx
                                                                        ) {
                                                                          return _c(
                                                                            "el-tag",
                                                                            {
                                                                              key: idx,
                                                                              staticClass:
                                                                                "form-tag",
                                                                              attrs:
                                                                                {
                                                                                  size: "mini",
                                                                                  type: "success",
                                                                                  effect:
                                                                                    "plain",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                  _vm._s(
                                                                                    val
                                                                                  ) +
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                              ),
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _vm.parseFormValue(
                                                                        scope
                                                                          .row
                                                                          .value
                                                                      )
                                                                        .length ===
                                                                      0
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "empty-value",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "--"
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                    2
                                                                  ),
                                                                ]
                                                              : [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "empty-value",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.formatFormValue(
                                                                            scope.row
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                          ]
                                                        : scope.row.type ===
                                                            "radio" ||
                                                          scope.row.type ===
                                                            "select"
                                                        ? [
                                                            scope.row.value
                                                              ? _c(
                                                                  "el-tag",
                                                                  {
                                                                    attrs: {
                                                                      size: "mini",
                                                                      type: "primary",
                                                                      effect:
                                                                        "plain",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        scope
                                                                          .row
                                                                          .value
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "empty-value",
                                                                  },
                                                                  [_vm._v("--")]
                                                                ),
                                                          ]
                                                        : scope.row.type ===
                                                          "dateSelect"
                                                        ? [
                                                            scope.row.value
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "date-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        scope
                                                                          .row
                                                                          .value
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "empty-value",
                                                                  },
                                                                  [_vm._v("--")]
                                                                ),
                                                          ]
                                                        : scope.row.type ===
                                                          "tips"
                                                        ? [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "tips-content",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row
                                                                      .value ||
                                                                      scope.row
                                                                        .placeholder ||
                                                                      "说明文字"
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        : scope.row.type ===
                                                          "phone"
                                                        ? [
                                                            scope.row.value
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "phone-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.formatPhoneNumber(
                                                                          scope
                                                                            .row
                                                                            .value
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "empty-value",
                                                                  },
                                                                  [_vm._v("--")]
                                                                ),
                                                          ]
                                                        : scope.row.type ===
                                                          "textarea"
                                                        ? [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "textarea-content",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row
                                                                      .value ||
                                                                      "--"
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        : [
                                                            scope.row.value
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        scope
                                                                          .row
                                                                          .value
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "empty-value",
                                                                  },
                                                                  [_vm._v("--")]
                                                                ),
                                                          ],
                                                      _vm._v(" "),
                                                      scope.row.valueId
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-value-id",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "值ID: " +
                                                                  _vm._s(
                                                                    scope.row
                                                                      .valueId
                                                                  )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3737725910
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "类型",
                                              width: "100",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "el-tag",
                                                        {
                                                          attrs: {
                                                            size: "mini",
                                                            type: _vm.getFormItemTagType(
                                                              scope.row.type
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                _vm.getFormItemTypeName(
                                                                  scope.row.type
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3197458277
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "div",
                                        { staticClass: "no-form-data" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-document",
                                          }),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("暂无表单数据")]),
                                        ]
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-divider"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  ![2, 3, 10, 18, 101, 102].includes(_vm.orderDatalist.type)
                    ? [
                        _c("div", { staticClass: "flex-btw" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("物流信息"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          [
                            _vm._l(_vm.transportOption, function (item) {
                              return _c(
                                "div",
                                {
                                  key: item.dataIndex,
                                  staticClass: "description-term",
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        item.title +
                                          "：" +
                                          ((_vm.orderDatalist.orderDelivery &&
                                            _vm.orderDatalist.orderDelivery[
                                              item.dataIndex
                                            ]) ||
                                            "--")
                                      ) +
                                      "\n\t\t\t\t\t"
                                  ),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.orderDatalist.kuaiDiInfoList || [],
                              function (logisticsInfo, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "description-term",
                                    staticStyle: {
                                      width: "100%",
                                      cursor: "pointer",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openLogistics(
                                          logisticsInfo.nu
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t物流信息" +
                                        _vm._s(index + 1) +
                                        "：" +
                                        _vm._s(
                                          logisticsInfo &&
                                            logisticsInfo.data &&
                                            logisticsInfo.data.length
                                            ? logisticsInfo.stateMsg +
                                                " - " +
                                                logisticsInfo.data[0].context +
                                                " - " +
                                                logisticsInfo.data[0].time +
                                                " - 【" +
                                                _vm.getDeliveryName(
                                                  logisticsInfo
                                                ) +
                                                " - " +
                                                logisticsInfo.nu +
                                                "】"
                                            : "--"
                                        ) +
                                        "\n\t\t\t\t\t"
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("el-divider"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  [2].includes(_vm.orderDatalist.type)
                    ? [
                        _c("div", { staticClass: "flex-btw" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("第三方卡券信息"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          _vm._l(_vm.thirdPartyCouponInfo, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.dataIndex,
                                staticClass: "description-term",
                                style: item.widthAll ? "width: 100%; " : "",
                              },
                              [
                                _c("div", { staticClass: "flex" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v(_vm._s(item.title) + "："),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.orderDatalist[item.dataIndex] ||
                                          item.uint ||
                                          "--"
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("el-divider"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  [10].includes(_vm.orderDatalist.type)
                    ? [
                        _c("div", { staticClass: "flex-btw" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("点餐信息"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          _vm._l(_vm.diningInfo, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.dataIndex,
                                staticClass: "description-term",
                                style: item.widthAll ? "width: 100%; " : "",
                              },
                              [
                                _c("div", { staticClass: "flex" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v(_vm._s(item.title) + "："),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.orderDatalist[item.dataIndex] ||
                                          item.uint ||
                                          "--"
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("el-divider"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  [4].includes(_vm.orderDatalist.type)
                    ? [
                        _c("div", { staticClass: "flex-btw" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("家政信息"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          _vm._l(_vm.housekeepingInfo, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.dataIndex,
                                staticClass: "description-term",
                                style: item.widthAll ? "width: 100%; " : "",
                              },
                              [
                                _c("div", { staticClass: "flex" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v(_vm._s(item.title) + "："),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.orderDatalist[item.dataIndex] ||
                                          item.uint ||
                                          "--"
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("el-divider"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  [8].includes(_vm.orderDatalist.type)
                    ? [
                        _c("div", { staticClass: "flex-btw" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("蛋糕信息"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          _vm._l(_vm.cakeInfo, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.dataIndex,
                                staticClass: "description-term",
                                style: item.widthAll ? "width: 100%; " : "",
                              },
                              [
                                _c("div", { staticClass: "flex" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v(_vm._s(item.title) + "："),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        (_vm.orderDatalist.storeDetail &&
                                          _vm.orderDatalist.storeDetail[
                                            item.dataIndex
                                          ]) ||
                                          _vm.orderDatalist[item.dataIndex] ||
                                          "--"
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("el-divider"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  [12].includes(_vm.orderDatalist.type)
                    ? [
                        _c("div", { staticClass: "flex-btw" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("自营卡券信息"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          [
                            !_vm.orderDatalist.platformCarmine ||
                            Object.keys(_vm.orderDatalist.platformCarmine)
                              .length === 0
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "description-term",
                                      staticStyle: { width: "100%" },
                                    },
                                    [
                                      _c("div", { staticClass: "flex" }, [
                                        _c("div", [
                                          _vm._v("暂无卡券信息或卡券尚未生成"),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ]
                              : _vm._l(
                                  _vm.selfOperatedCouponInfo,
                                  function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.dataIndex,
                                        staticClass: "description-term",
                                        style: item.widthAll
                                          ? "width: 100%; "
                                          : "",
                                      },
                                      [
                                        _c("div", { staticClass: "flex" }, [
                                          _c(
                                            "div",
                                            { staticClass: "item-title" },
                                            [_vm._v(_vm._s(item.title) + "：")]
                                          ),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.orderDatalist
                                                  .platformCarmine[
                                                  item.dataIndex
                                                ] || "--"
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    )
                                  }
                                ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("el-divider"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [_vm._v("商品明细")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    [
                      _c(
                        "el-table",
                        {
                          staticClass: "table",
                          attrs: {
                            data: _vm.orderDatalist.orderItemList || [],
                            size: "mini",
                            "highlight-current-row": "",
                            "header-cell-style": { fontWeight: "bold" },
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuId",
                              label: "skuID",
                              "min-width": "50",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuCode",
                              label: "编号",
                              "min-width": "140",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuName",
                              label: "名称",
                              "min-width": "140",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuAttr",
                              label: "销售属性",
                              "min-width": "120",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuQuantity",
                              label: "数量",
                              "min-width": "60",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      Number(_vm.orderDatalist.type) === 18
                                        ? _c(
                                            "el-link",
                                            {
                                              attrs: {
                                                type: "primary",
                                                underline: false,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$refs.oneCardOrderItemDialog.open(
                                                    _vm.orderNo,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    scope.row.skuQuantity
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              ),
                                            ]
                                          )
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.skuQuantity)
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              363540746
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuPrice",
                              label: "单价",
                              "min-width": "60",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuTotalPrice",
                              label: "总价",
                              "min-width": "60",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuTotalPrice",
                              label: "图片",
                              "min-width": "60",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return scope.row.skuImg
                                      ? _c("el-image", {
                                          staticStyle: {
                                            width: "46px",
                                            height: "46px",
                                          },
                                          attrs: {
                                            src: scope.row.skuImg,
                                            "preview-src-list": [
                                              scope.row.skuImg,
                                            ],
                                          },
                                        })
                                      : _vm._e()
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "发货状态", "min-width": "80" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type:
                                              scope.row.isShipped === 1
                                                ? "success"
                                                : "warning",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                scope.row.isShipped === 1
                                                  ? "已发货"
                                                  : "未发货"
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              255241233
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "关联售后", "min-width": "130" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return _vm._l(
                                      scope.row.aftersaleAndAmount || [],
                                      function (item) {
                                        return _c(
                                          "div",
                                          {
                                            key: item
                                              ? item.afterSaleId
                                              : "no-id",
                                          },
                                          [
                                            item && item.afterSaleId
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.navigateToAftersaleDetail(
                                                          item.afterSaleId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.afterSaleId) +
                                                        "-" +
                                                        _vm._s(item.amount) +
                                                        "元"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    )
                                  },
                                },
                              ],
                              null,
                              false,
                              1617478999
                            ),
                          }),
                          _vm._v(" "),
                          _vm.hasSelfOneCardItem
                            ? _c("el-table-column", {
                                attrs: { label: "是否激活", "min-width": "90" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          Number(scope.row.oneCardType) !== 1
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.oneCardActivated
                                                      ? "是"
                                                      : "否"
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2063875074
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [_vm._v("支付明细")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    _vm._l(_vm.priceOption, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: item.dataIndex,
                          staticClass: "description-term price-item",
                          style: { width: "33.33%", display: "inline-block" },
                        },
                        [
                          _c("div", { staticClass: "flex" }, [
                            _c(
                              "div",
                              {
                                staticClass: "item-title price-title",
                                staticStyle: { "text-align": "right" },
                              },
                              [_vm._v(_vm._s(item.title) + "：")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "price-title price-num",
                                style:
                                  "" +
                                  (item.isWarning
                                    ? "color: red"
                                    : "color: #303133"),
                              },
                              [
                                _vm._v(
                                  _vm._s(item.uint) +
                                    _vm._s(
                                      (_vm.orderDatalist &&
                                        _vm.orderDatalist.orderPay &&
                                        _vm.orderDatalist.orderPay[
                                          item.dataIndex
                                        ]) ||
                                        "--"
                                    )
                                ),
                                item.dataIndex === "paidPrice" &&
                                _vm.orderDatalist &&
                                _vm.orderDatalist.orderPay &&
                                Number(_vm.orderDatalist.orderPay.paidPrice) >
                                  0 &&
                                _vm.orderDatalist.orderPay.payChannel
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-left": "8px",
                                          color: "#909399",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "(" +
                                            _vm._s(
                                              _vm.orderDatalist.orderPay
                                                .payChannel
                                            ) +
                                            ")"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [_vm._v("优惠方式")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "discount-method-row" }, [
                    _c(
                      "div",
                      { staticClass: "discount-method-left" },
                      [
                        _c("span", [_vm._v("优惠方式：优惠券或立减活动 ")]),
                        _vm._v(" "),
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary", underline: true },
                            on: { click: _vm.openDiscountDetail },
                          },
                          [_vm._v("优惠记录")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "discount-amount-lines" }, [
                      _c("div", { staticClass: "discount-line" }, [
                        _vm._v(
                          "优惠券优惠: -¥" +
                            _vm._s(
                              _vm.formatDiscountAmount(
                                _vm.orderDatalist &&
                                  _vm.orderDatalist.orderPay &&
                                  _vm.orderDatalist.orderPay
                                    .couponDiscountAmount
                              )
                            )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "discount-line" }, [
                        _vm._v(
                          "加油立减优惠: -¥" +
                            _vm._s(
                              _vm.formatDiscountAmount(
                                _vm.orderDatalist &&
                                  _vm.orderDatalist.orderPay &&
                                  _vm.orderDatalist.orderPay
                                    .immediateDiscountAmount
                              )
                            )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "discount-line" }, [
                        _vm._v(
                          "立减优惠: -¥" +
                            _vm._s(
                              _vm.formatDiscountAmount(
                                _vm.orderDatalist &&
                                  _vm.orderDatalist.instantDiscountAmount
                              )
                            )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "discount-line" }, [
                        _vm._v(
                          "新人价优惠: -¥" +
                            _vm._s(
                              _vm.formatDiscountAmount(
                                _vm.orderDatalist &&
                                  _vm.orderDatalist.orderPay &&
                                  _vm.orderDatalist.orderPay
                                    .newcomerDiscountAmount
                              )
                            )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "discount-line" }, [
                        _vm._v(
                          "活动福利立减金额: -¥" +
                            _vm._s(
                              _vm.formatDiscountAmount(
                                _vm.orderDatalist &&
                                  _vm.orderDatalist.orderPay &&
                                  _vm.orderDatalist.orderPay.luckyDiscountAmount
                              )
                            )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  !_vm.shouldHideLogList
                    ? _c("div", { staticClass: "title" }, [_vm._v("日志列表")])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.shouldHideLogList
                    ? _c(
                        "div",
                        { staticClass: "acea-row" },
                        [
                          !_vm.orderDatalist.orderLogList ||
                          _vm.orderDatalist.orderLogList.length === 0
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass: "description-term",
                                    staticStyle: {
                                      width: "100%",
                                      "text-align": "center",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t暂无订单日志\n\t\t\t\t\t\t"
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _c(
                                  "el-table",
                                  {
                                    staticClass: "table",
                                    attrs: {
                                      data:
                                        _vm.orderDatalist.orderLogList || [],
                                      size: "mini",
                                      "highlight-current-row": "",
                                      "header-cell-style": {
                                        fontWeight: "bold",
                                      },
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "createTime",
                                        label: "时间",
                                        "min-width": "150",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      scope.row.createTime ||
                                                        "--"
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2729224068
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "operate",
                                        label: "操作人",
                                        "min-width": "100",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      scope.row.operate || "--"
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2589247437
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "content",
                                        label: "日志明细",
                                        "min-width": "300",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.shouldHideLogList ? _c("el-divider") : _vm._e(),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "优惠记录",
            visible: _vm.discountDetailVisible,
            width: "780px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.discountDetailVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.discountDetailLoading,
                  expression: "discountDetailLoading",
                },
              ],
              attrs: {
                data: _vm.discountDetailList,
                size: "small",
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "discountTypeName", label: "类型", width: "90" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponId",
                  label: "优惠券id",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponName",
                  label: "优惠券名称",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "优惠金额", width: "100", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(
                            "-¥" +
                              _vm._s(_vm.formatDiscountAmount(scope.row.amount))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "receiveTimeStr",
                  label: "领取时间",
                  width: "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "usedTimeStr", label: "使用时间", width: "160" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "startTime", label: "有效期开始", width: "160" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "endTime", label: "有效期结束", width: "160" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.discountDetailLoading &&
          (!_vm.discountDetailList || _vm.discountDetailList.length === 0)
            ? _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    padding: "20px",
                    color: "#909399",
                  },
                },
                [_vm._v("暂无优惠记录")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("OneCardOrderItemDialog", { ref: "oneCardOrderItemDialog" }),
      _vm._v(" "),
      _c("TransportTrace", { ref: "TransportTraceRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }